import * as React from "react"
import { useMemo } from "react"
import type { RenderPack } from "@cogo/runtime-v2"
import { materializeRenderPackTree } from "@cogo/runtime-v2"
import { CogoBlock, type ThemeTokens } from "./cogo-block"
import type { CogoBlockDef } from "../core/types"

export interface RenderPackBlockProps {
  renderPack?: RenderPack
  renderPackBytes?: Uint8Array
  themeTokens?: ThemeTokens
}

export function materializeRenderPackBlock(renderPackOrBytes: RenderPack | Uint8Array): CogoBlockDef {
  const materialized = materializeRenderPackTree(renderPackOrBytes)
  if (!materialized.root) {
    throw new Error("RenderPackBlock requires a RenderPack with a materializable root node.")
  }

  return {
    schemaVersion: "cogo-render-pack.v1",
    blockType: "render-pack",
    root: materialized.root as unknown as CogoBlockDef["root"],
  }
}

export function RenderPackBlock({ renderPack, renderPackBytes, themeTokens }: RenderPackBlockProps) {
  const block = useMemo(() => {
    const input = renderPackBytes ?? renderPack
    if (!input) {
      throw new Error("RenderPackBlock requires renderPackBytes or renderPack.")
    }
    return materializeRenderPackBlock(input)
  }, [renderPack, renderPackBytes])

  return <CogoBlock block={block} themeTokens={themeTokens} />
}
